import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { Lab_Interface } from 'src/app/Interface/Lab_Interface';
import { Listener } from 'selenium-webdriver';
import { General_Interface } from 'src/app/Interface/General_Interface';

@Injectable({
  providedIn: 'root'
})
export class LabService {

  constructor(private http: HttpClient) { }

  Get(StartDate_ReceiveDate: String,
    EndDate_ReceiveDate: String,

    StartDate_DownloadDate: String,
    EndDate_DownloadDate: String,

    StartDate_UploadDate: String,
    EndDate_UploadDate: String,

    SubmitPeriodDate_ReceiveDate: number,
    SubmitPeriodDate_DownloadDate: number,
    SubmitPeriodDate_UploadDate: number,

    Customer: String,
    Type_Lap: number,
    Token: String
  ): Observable<Array<Lab_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab?token=" + Token

      + "&StartDate_ReceiveDate=" + StartDate_ReceiveDate
      + "&EndDate_ReceiveDate=" + EndDate_ReceiveDate

      + "&StartDate_DownloadDate=" + StartDate_DownloadDate
      + "&EndDate_DownloadDate=" + EndDate_DownloadDate

      + "&StartDate_UploadDate=" + StartDate_UploadDate
      + "&EndDate_UploadDate=" + EndDate_UploadDate

      + "&SubmitPeriodDate_ReceiveDate=" + SubmitPeriodDate_ReceiveDate
      + "&SubmitPeriodDate_DownloadDate=" + SubmitPeriodDate_DownloadDate
      + "&SubmitPeriodDate_UploadDate=" + SubmitPeriodDate_UploadDate


      + "&Type_Lap=" + Type_Lap
      + "&CustomerName=" + Customer
    ).pipe(
      map(data => {
        return data as Array<Lab_Interface>
      })
    )
  }

  GetLabCalibration(Token: String): Observable<Array<Lab_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetLabCalibration?token=" + Token).pipe(
        map(data => {
          return data as Array<Lab_Interface>
        })
      )
  }

  GetDetailDownloadCount(Token: String): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetDetailDownloadCount?token=" + Token).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  GetLabConfirmCalibration(Token: String): Observable<Array<Lab_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetLabConfirmCalibration?token=" + Token).pipe(
        map(data => {
          return data as Array<Lab_Interface>
        })
      )
  }

  GetLabCertificate(Token: String): Observable<Array<Lab_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetLabCertificate?token=" + Token).pipe(
        map(data => {
          return data as Array<Lab_Interface>
        })
      )
  }

  GetDetailCount(Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetDetailCount?token=" + Token).pipe(
        map(data => {
          return data as any
        })
      )
  }

  PostDownload(code: Array<string>, id: number, Token: String): Observable<Array<General_Interface>> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id: id,
      Token: Token,
      code: code,
    }

    return this.http.post(environment.BaseUrl + "Daro/Lab/PostDownload", body, { headers }).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )

  }

  PostDownloadHamKar(code: Array<string>,
    userDsc: Array<string>,
    id: number,
    Subject_id: number,
    Customer_id: number,
    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id: id,
      Customer_id: Customer_id,
      Subject_id: Subject_id,
      Token: Token,
      code: code,
      userDsc: userDsc,
    }

    return this.http.post(environment.BaseUrl + "Daro/Lab/PostDownloadHamKar", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  GetRequestExit(Token: String): Observable<Array<Calibration_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetRequestExit?token=" + Token).pipe(
        map(data => {
          return data as Array<Calibration_Interface>
        })
      )
  }


  AnswerReviewExit(id: number,status: number,  Token: String, dsc: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Lab/AnswerReviewExit?id=" + id
      + "&status=" + status
      + "&dsc=" + dsc
      + "&token=" + Token).pipe(
      map(data => {
        return data as any
      })
    )

  }

  PostUpload(code: Array<string>, Token: String): Observable<Array<General_Interface>> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      Token: Token,
      code: code,
    }


    return this.http.post(environment.BaseUrl + "Daro/Lab/PostUpload", body, { headers }).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )

  }

  PostExit(code: String, dsc: String, Token: String): Observable<Calibration_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {}


    return this.http.post(environment.BaseUrl + "Daro/Lab/PostExit?Code=" + code + "&dsc=" + dsc + "&Token=" + Token, body, { headers }).pipe(
      map(data => {
        return data as Calibration_Interface
      })
    )

  }

  SubmitCalibrationDate(id: number, dsc: String, Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {}


    return this.http.post(environment.BaseUrl + "Daro/Lab/SubmitCalibrationDate?id=" + id
      + "&dsc=" + dsc
      + "&Token=" + Token, body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  SubmitExpertCalibrationDate(id: number, Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {}


    return this.http.post(environment.BaseUrl + "Daro/Lab/SubmitExpertCalibrationDate?id=" + id
      + "&Token=" + Token, body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }


  RequestExit(id: number,dsc: String,Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/RequestExit?token=" + Token+"&id="+id+"&dsc="+dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }


}
